import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyD6S2dILlwKETij2-X6jlRWasZwIzmvdp8',
  authDomain: 'sw-it-v01.firebaseapp.com',
  databaseURL: 'https://sw-it-v01-default-rtdb.firebaseio.com',
  projectId: 'sw-it-v01',
  storageBucket: 'sw-it-v01.firebasestorage.app',
  messagingSenderId: '1000586137880',
  appId: '1:1000586137880:web:7984aaae42070bb5dc0e6d',
  measurementId: 'G-Y5R0S9SGPD'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Auth
const auth = getAuth(app);

export { db, auth }; 